import { render, staticRenderFns } from "./BestHit.vue?vue&type=template&id=2ac64394&scoped=true&"
import script from "./BestHit.vue?vue&type=script&lang=js&"
export * from "./BestHit.vue?vue&type=script&lang=js&"
import style0 from "./BestHit.vue?vue&type=style&index=0&id=2ac64394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac64394",
  null
  
)

export default component.exports